//const idComparator = (a, b) => a === b;
export const rules = {

  // required: (value) => !!value || 'Boş Bırakılamaz.',
  required: (value) => {
    console.log("REquired Function:", value);
    if (Array.isArray(value)) {
      return value.length > 0 || 'Boş Bırakılamaz.'
    }
    else if ((typeof value) == "string") {
      return value.length > 0 || 'Boş Bırakılamaz.';
    }
    return !!value || 'Boş Bırakılamaz.';
  },
  requiredList: (value) => value.length > 0 || 'Boş Bırakılamaz.',
  counter: value => value.length <= 20 || 'Max 20 characters',
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    console.log("Email Validate:",value);
    return (value!==undefined  && (value.length == 0 || pattern.test(value))) || 'Mail formatında olmalıdır.'
  },
  number: value => typeof (value) == 'number' || 'Sayı olmalıdır.',
  empty: value => !!value || 'Boş Bırakılamaz.',
  filesize: (value,size) =>{
    console.log("filesize :",value,this.size);
    return   !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!'} 
  // your code
}

export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
export const CustomFunc = {
  toggleElement: (arr, val, compFn = (a, b) => a === b) => {
    const res = arr.filter(v => !compFn(v, val));
    if (res.length === arr.length) res.push(val);
    return res;
  }
}


export const tableToExcel = (function () {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
    , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
  return function (table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
    console.log("tableİnnerHtml,", table);
    window.location.href = uri + base64(format(template, ctx))
  }
})()
export const tableObjToExcel = (function () {
  var uri = 'data:application/vnd.ms-excel;base64,'
    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
    , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
    , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
  return function (table, name) {
    if (!table.nodeType) table = document.getElementById(table)
    var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
    console.log("tableİnnerHtml,", table);
    window.location.href = uri + base64(format(template, ctx))
  }
})()
// var rules = {
//     required: value => !!value || 'Required.',
//     counter: value => value.length <= 20 || 'Max 20 characters',
//     email: value => {
//         const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//         return (value.length == 0 || pattern.test(value)) || 'Mail formatında olmalıdır.'
//     },
//     number: value => typeof (value) == 'number' || 'Sayı olmalıdır.'
// };
// function uuidv4() {
//     return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
//         (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
//     );
// };
